<template>
  <div class="ui">
    <div class="title">
      <h3 class="ui dividing header fdinpro default-header-green is-uppercase">
        {{ $t("bloque de codigos") }} <i class="dropdown icon"></i>
      </h3>
    </div>
    <div class="content field">
      <div class="ui form" ref="formUpload">
        <label class="fdinpro label-form">{{ $t("subir excel") }}</label>
        <input type="file" @change="onChange" />
        <div
          class="ui fluid button modal-button-green is-capitalized"
          tabindex="0"
        >
          {{ $t("send") }}
        </div>
      </div>
    </div>
    <excel-modal ref="excel_modal" />
  </div>
</template>

<script>
import { local_api, enterprise_setup, api_host } from "@/utils";
// import uuid from "uuid/v4";
// Import FilePond styles
import ExcelModal from "./ExcelModal.vue";
import readXlsxFile from "read-excel-file";

export default {
  components: {
    ExcelModal,
  },
  name: "NvidiaTicketStoreExcelUpload",
  data() {
    return {
      files: [],
      api_host: api_host,
      bundles: [],
    };
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        let isValid = vm.form.form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/nworkforce/store/do-save", {
            i: vm.document ? vm.document.uuid : undefined,
            s: { files: vm.files },
          })
            .then((document) => {
              vm.$emit("succedded", document);
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    onChange(event) {
      let vm = this;
      vm.file = event.target.files ? event.target.files[0] : null;
      readXlsxFile(vm.file)
        .then((rows) => {
          vm.$refs.excel_modal.show(rows);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setBundles(bundles) {
      this.bundles = bundles;
      this.$refs.excel_modal.setBundles(bundles);
    },
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #ffffff !important;
  font-weight: 300;
  color: #ffffff !important;
  font-size: 1.5rem !important;
  margin-top: 40px !important;
}
.label-form {
  font-size: 0.8rem !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
.ui.container {
  width: auto !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.is-capitalized {
  text-transform: capitalize !important;
}
</style>
